const reasons = [
  {
    icon: "ri-shield-check-line",
    title: "Проверенные ссылки",
    desc: "Все ссылки проходят проверку качества. Только надёжные продавцы и качественные товары.",
  },
  {
    icon: "ri-refresh-line",
    title: "Регулярные обновления",
    desc: "Таблицы обновляются каждую неделю. Новые находки, новые тренды, новые бренды.",
  },
  {
    icon: "ri-stack-line",
    title: "Широкий выбор",
    desc: "14 категорий товаров: от кроссовок до парфюмерии. Всё, что вам нужно, в одном месте.",
  },
  {
    icon: "ri-timer-line",
    title: "Экономия времени",
    desc: "Не тратьте часы на поиски. Мы уже собрали лучшее для вас в удобных таблицах.",
  },
];

export default function WhySection() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            Почему стоит использовать наши таблицы?
          </h2>
          <p className="text-foreground-600 text-sm max-w-lg mx-auto">
            Мы делаем шоппинг проще и выгоднее
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {reasons.map((item, i) => (
            <div
              key={i}
              className="flex flex-col items-center text-center p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all group"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-200 transition-colors mb-4">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 text-sm md:text-base mb-2">
                {item.title}
              </h3>
              <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}